module.exports = __webpack_public_path__ + "static/media/landscape10.8a3fbabb.jpg";